
//https://scalablecss.com/styled-components-global-styles/

import 'bootstrap/dist/css/bootstrap.min.css';
import { createGlobalStyle } from 'styled-components';
import loginBgir from '../images/loginbgir.jpg'
// PRECISA IMPORTAR

const GlobalStyle = createGlobalStyle`
 * { 
    /* // background: white;  NÃO PODE TER ESTE BACKGROUND */
    margin:0px;
    padding:0px;
    outline:0;
    -webkit-font-smoothing: antialiased;

    /* DEVE ESTAR NO BODY */
    body {
        
        background-color: whitesmoke; /* Used if the image is unavailable */
        
    }

    
.classland{
        background-image: url(${loginBgir})  ; 
        width:100%;
        background-size: cover ; 
        background-attachment: fixed;
        background-origin: padding-box;
        background-repeat: repeat-y; 
        background-position: top;
        border: 1px solid black;
}


.alturaminima{
    min-height:70vh;
}


  }
`;


export default GlobalStyle
